export interface ISubmitResponse {
  readonly success?: boolean;
  readonly confirmationNumber?: string;
  readonly serviceRequestID: string;
  readonly sendToBetaFlag: boolean;
  readonly complete: boolean;
  readonly isS24Reject: boolean;
  readonly toaRequestID: string;
  readonly brokerageAccountNumber: string;
  readonly outcome: string;
  readonly isEdeliveryEnrolled: boolean;
  readonly failedId: string;
  readonly isWebRegistrationSuccessful: boolean;
  readonly s24Status: string;
  readonly sendToAWD: boolean;
  readonly accountId: string;
}

export interface IAOASubmitResponse extends ISubmitResponse {
  readonly automatedBrokerageApprovalStatus: string;
  readonly failedRuleIds: string[];
  readonly eventId: string;
}
